// per-tab 状态条：灯 + 阶段 + Wave/Round + 进度条。
// per-tab status bar: lamp + phase + Wave/Round + progress fill.

import type { TabState } from "@/features/log-terminal/terminal-types";

// 灯语义对应的默认文案
// Default copy per lamp state; a non-null `message` is appended as an extra segment.
const DEFAULT_COPY: Record<TabState["lamp"], string> = {
  idle: "Idle",
  queued: "Queued",
  running: "Running",
  completed: "Completed",
  failed: "Failed",
  cancelled: "Cancelled",
};

export interface StatusBarHandle {
  root: HTMLElement;
}

/** 创建一个状态条容器 / Create the empty status-bar shell. */
export function createStatusBar(): StatusBarHandle {
  const root = document.createElement("div");
  root.className = "terminal-status";
  root.innerHTML = `
    <span class="terminal-status-lamp" aria-hidden="true"></span>
    <span class="terminal-status-text"></span>
    <span class="terminal-status-bar" role="progressbar" aria-valuemin="0" aria-valuemax="100">
      <span class="terminal-status-bar-fill" style="width: 0%"></span>
    </span>
  `;
  return { root };
}

/** 按 state 更新状态条 / Apply a TabState to the status bar. */
export function updateStatusBar(root: HTMLElement, state: TabState): void {
  const lamp = root.querySelector<HTMLElement>(".terminal-status-lamp")!;
  lamp.className = `terminal-status-lamp ${state.lamp}`;

  const text = root.querySelector<HTMLElement>(".terminal-status-text")!;
  const parts: string[] = [DEFAULT_COPY[state.lamp]];
  if (state.message) parts.push(state.message);
  if (state.phaseLabel) parts.push(state.phaseLabel);
  if (state.wave != null && state.totalWaves != null) {
    parts.push(`Wave ${state.wave + 1}/${state.totalWaves}`);
  } else if (state.round != null && state.totalRounds != null) {
    parts.push(`Deliberation Round ${state.round}/${state.totalRounds}`);
  }
  text.textContent = parts.join(" · ");

  const fill = root.querySelector<HTMLElement>(".terminal-status-bar-fill")!;
  const terminalStates: TabState["lamp"][] = ["completed", "failed", "cancelled"];
  const width = terminalStates.includes(state.lamp)
    ? 100
    : Math.max(0, Math.min(100, Math.round(state.progress * 100)));
  fill.style.width = `${width}%`;
}
